import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { FC, useState } from "react";
import { JourneyProfileEditor } from "../journey/JourneyProfileEditor";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    width: "450px",
    maxWidth: "90%",
  },

  actions: {
    display: "flex",
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    gap: theme.spacing(2),
  },
  actionButton: {
    flex: 1,
  },
}));

interface Props {
  open: boolean;
  onClose: () => void;
  onSave: (payload: { name: string; subtitle?: string; avatar: string }) => void;
  isPending?: boolean;
}

export const JourneyProfileDialog: FC<Props> = ({
  open,
  onClose,
  onSave,
  isPending = false,
}) => {
  const s = useStyles();
  const [name, setName] = useState("");
  const [subtitle, setSubtitle] = useState(null as string | null);
  const [avatar, setAvatar] = useState("");

  const handleSave = () => {
    if (name.trim()) {
      onSave({ name, subtitle, avatar });
      setName("");
      setAvatar("");
      handleClose();
    }
  };

  const handleClose = () => {
    setName("");
    setAvatar("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{ paper: s.dialogPaper }}
    >
      <DialogTitle>Create New Profile</DialogTitle>

      <DialogContent>
        <JourneyProfileEditor
          name={name}
          setName={setName}
          subtitle={subtitle}
          setSubtitle={setSubtitle}
          avatar={avatar}
          setAvatar={setAvatar}
        />
      </DialogContent>

      <DialogActions className={s.actions}>
        <Button
          className={s.actionButton}
          variant="outlined"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          className={s.actionButton}
          variant="contained"
          onClick={handleSave}
          disabled={isPending || !name.trim()}
        >
          Save Profile
        </Button>
      </DialogActions>
    </Dialog>
  );
};
